import React from 'react';
import { motion } from 'framer-motion';

export const MoreInfoModal = ({ onClose }) => {
    
  return (
    <motion.div
      className="fixed top-0 left-0 h-full w-1/3 bg-gray-800 text-white p-4 z-50 shadow-lg"
      initial={{ y: '-100%', opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: '-100%', opacity: 0 }}
      transition={{ type: 'anticipate', stiffness: 100, damping: 20 }}
    >
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">More Info</h2>
        <button onClick={onClose} className="text-2xl leading-none">
          &times;
        </button>
      </div>
      <div className="flex mb-4">
        {/* Explorer on the left */}
        <div className="w-1/2 pr-2 border-r border-gray-600">
          <h3 className="font-semibold mb-2">Explorer</h3>
          <em className="text-gray-600">coming soon</em>
        </div>
        {/* Filter Transactions on the right of Explorer */}
        <div className="w-1/2 pl-2">
          <h3 className="font-semibold mb-2">Filter Transactions</h3>
          <em className="text-gray-600">coming soon</em>
        </div>
      </div>
      {/* Transactions component below */}
      <div>
        <h3 className="font-semibold mb-2">Transactions</h3>
        <em className="text-gray-600">coming soon</em>
      </div>
    </motion.div>
  );
};
